import { twMerge } from "tailwind-merge";

interface CheckboxProps {
  isChecked: boolean;
  label?: string;
  onCheck?: (isChecked: boolean) => void;
}

export default function Checkbox({
  isChecked,
  label = "",
  onCheck,
}: CheckboxProps) {
  return (
    <div className="flex items-center gap-1">
      <div
        className={twMerge(
          "aspect-square w-4 cursor-pointer rounded-sm border border-zinc-300 transition-colors duration-300",
          isChecked && "bg-zinc-100"
        )}
        onClick={() => {
          if (!!onCheck) {
            onCheck(!isChecked);
          }
        }}
      >
        {isChecked && (
          <i className="bi bi-check-lg flex h-full w-full items-center justify-center text-zinc-500" />
        )}
      </div>
      {label && <span className="text-sm">{label}</span>}
    </div>
  );
}
